

import { MapCoordinates } from '@repo/ui/features/inventaires/map-view/providers';
import { Epaysage } from '@repo/types';
import { EpaysageBasicFormInitialValues } from '../forms/epaysage-basic-form';

interface EpaysageWithInventaire extends Epaysage {
  inventaire?: { id: number | null } | null;
  zip_code?: string | null;
}

export function mapEpaysageToBasicInitialValues(
  epaysage: EpaysageWithInventaire,
  coordinates?: MapCoordinates[] | null,
  inventaireId?: number
): {
  initialValues: EpaysageBasicFormInitialValues;
  polygon: MapCoordinates[];
  inventaireId?: number;
} {
  return {
    initialValues: {
      address: epaysage.address ?? '',
      ville: epaysage.ville ?? '',
      pays: epaysage.pays ?? '',
      area: epaysage.area ? String(epaysage.area) : '',
      type_espace: epaysage.type_espace ?? '',
      type_espace_autre: epaysage.type_espace_autre ?? '',
      code_site: epaysage.code_site ?? '',
      num_sujet: epaysage.num_sujet ?? '',
      age_estime: epaysage.age_estime ? String(epaysage.age_estime) : '',
      zip_code: epaysage.zip_code ?? '',
    },
    polygon: coordinates ?? [],
    inventaireId: inventaireId ?? epaysage.inventaire?.id ?? undefined,
  };
}

